import React from 'react';
import { FadeIn, Section } from './Shared';
import { Square } from 'lucide-react';
export const IdentificationSection = () => {
  const symptoms = ['Te levantas cansada incluso después de dormir', 'Tu abdomen se inflama aunque comas “bien”', 'A las 3 PM te da un bajón de energía fuerte', 'Has probado dietas, ejercicio o suplementos… sin resultados'];
  return <Section bg="white" data-id="element-144">
      <FadeIn data-id="element-145">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-146">
          Si te sientes así, esto es para ti:
        </h2>
      </FadeIn>

      <div className="max-w-2xl mx-auto space-y-3 mb-8" data-id="element-147">
        {symptoms.map((symptom, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-148">
            <div className="flex items-start gap-4 p-4 rounded-xl bg-brand-cream/50 border border-brand-cream hover:border-brand-teal/30 transition-colors" data-id="element-149">
              <Square className="w-6 h-6 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-150" />
              <p className="text-lg text-gray-800 font-medium" data-id="element-151">{symptom}</p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.5} data-id="element-152">
        <div className="text-center" data-id="element-153">
          <p className="text-xl md:text-2xl text-gray-600 mb-2" data-id="element-154">
            No es falta de disciplina. No es la edad.
          </p>
          <p className="text-2xl md:text-3xl font-bold text-brand-teal font-heading" data-id="element-155">
            Es tu hígado pidiendo ayuda.
          </p>
        </div>
      </FadeIn>
    </Section>;
};